import type {ReactElement} from 'react';

export type ModelBrand = 'claude' | 'gemini' | 'openai' | 'seedance';

interface ModelBrandVisualProps {
  readonly brand: ModelBrand;
  readonly modelVersion: string;
}

const logos = {
  gemini: new URL('../../assets/providers/gemini-spark.png', import.meta.url).href,
  openai: new URL('../../assets/providers/openai-wordmark-white.svg', import.meta.url).href,
  seedance: new URL('../../assets/providers/bytedance-seed-wordmark.png', import.meta.url).href
};

const backgrounds: Record<Exclude<ModelBrand, 'claude'>, string> = {
  gemini: new URL('../../assets/providers/gemini-visual-research.png', import.meta.url).href,
  openai: new URL('../../assets/providers/openai-screenplay.png', import.meta.url).href,
  seedance: new URL('../../assets/providers/seedance-action.png', import.meta.url).href
};

export const ModelBrandVisual = ({brand, modelVersion}: ModelBrandVisualProps): ReactElement => (
  <div className="model-brand-visual relative isolate h-68 overflow-hidden bg-[#151419]">
    {brand === 'claude'
      ? <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(120%_90%_at_20%_10%,#d9774a55,transparent_55%),radial-gradient(90%_80%_at_85%_20%,#9b6bff44,transparent_60%),linear-gradient(160deg,#241a24,#151419)]" />
      : <img alt="" className="absolute inset-0 size-full object-cover" height={1024} loading="lazy" src={backgrounds[brand]} width={1536} />}
    <div className="absolute inset-0 bg-linear-to-t from-[#151419] via-[#151419]/15 to-transparent" />
    <div className="absolute inset-x-4 bottom-14 flex h-20 flex-col items-center justify-center gap-3">
      {brand === 'openai' && <h3 className="flex h-16 w-full items-center justify-center"><img alt="OpenAI" className="h-auto w-64 max-w-full" height={718} src={logos.openai} width={1604} /></h3>}
      {brand === 'claude' && <h3 className="font-sans text-[40px] leading-none font-medium tracking-tight text-white md:text-[32px] lg:text-[40px]">Claude</h3>}
      {brand === 'gemini' && <h3 className="flex items-center gap-3 font-sans text-[40px] leading-none font-medium tracking-tight text-white md:gap-2 md:text-[32px] lg:gap-3 lg:text-[40px]"><img alt="" className="size-12 shrink-0 md:size-10 lg:size-12" height={560} src={logos.gemini} width={560} />Gemini</h3>}
      {brand === 'seedance' && <>
        <span className="rounded-sm bg-white/95 px-2.5 py-1.5"><img alt="ByteDance Seed" className="h-auto w-28" height={96} src={logos.seedance} width={720} /></span>
        <h3 className="font-sans text-[32px] leading-none font-medium tracking-tight whitespace-nowrap text-white md:text-[26px] lg:text-[32px]">Seedance <span className="font-normal">2.5</span></h3>
      </>}
    </div>
    <p className="absolute inset-x-4 bottom-3 text-center font-navigation">
      <span className="block text-[9px] leading-4 font-medium tracking-[.18em] text-zinc-400 uppercase">API model</span>
      <span className="block text-xs leading-5 font-medium text-violet-200">{modelVersion}</span>
    </p>
  </div>
);
